import * as yup from 'yup';
const cpfRegex = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
const cnpjRegex = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;

yup.addMethod(yup.string, 'cpf', function () {
  return this.test('cpf', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && cpfRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid CPF', type: 'cpf' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'cnpj', function () {
  return this.test('cnpj', function () {
    const { path, createError } = this;
    const field = document.getElementsByName(path)[0];
    return new Promise((resolve, reject) => {
      if (field && cnpjRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid CNPJ', type: 'cnpj' }));
      }
    });
  });
});

const schema = yup.object().shape({
  name: yup
    .string()
    .required()
    .trim(),
  socialName: yup
    .string()
    .required()
    .trim(),
  cpf: yup.string().when('type', {
    is: value => value === '1',
    then: yup.string().cpf()
  }),
  cnpj: yup.string().when('type', {
    is: value => value === '2',
    then: yup.string().cnpj()
  }),
  additionalInformation: yup
    .string()
    .required()
    .trim()
});

export default schema;
